// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NotificationFilledSvg from "@ant-design/icons-svg/es/asn/NotificationFilled";
import AntdIcon from '../components/AntdIcon';

var NotificationFilled = function NotificationFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: NotificationFilledSvg
  }));
};

NotificationFilled.displayName = 'NotificationFilled';
export default React.forwardRef(NotificationFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/NotificationFilled.js
// module id = 1523
// module chunks = 0